import { CommentIndicator } from 'features/libra/comments/CommentIndicator'
import { wrapFieldValue } from 'features/libra/ontology/ontologyFieldDefaults'
import type { SectionRenderProps } from 'features/libra/sections/sectionTypes'
import { ConsequenceOfFailureSection } from 'features/libra/stepComponents/zoneAnalysis/components/ConsequenceOfFailureSection'
import { CofAiPrefillButton } from 'features/libra/stepComponents/zoneAnalysis/components/ZoneTicketAiPrefillActions'
import type { ConsequenceOfFailure } from 'features/libra/stepComponents/zoneAnalysis/niiStrategy'
import {
  parseCofFromFieldValues,
  ZONE_FIELD_IDS,
} from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'
import { FC, useCallback, useMemo } from 'react'
import { RolodexPermissionsValues } from 'types'

import type { ConsequenceOfFailureSection as ConsequenceOfFailureSectionConfig } from './consequenceOfFailureSectionTypes'

export const ConsequenceOfFailureSectionView: FC<
  SectionRenderProps<ConsequenceOfFailureSectionConfig>
> = ({ config, stepId, fieldValues, setFieldValues }) => {
  const readonly = !setFieldValues

  const cof = useMemo(
    () => parseCofFromFieldValues(fieldValues).cof,
    [fieldValues]
  )

  const onChange = useCallback(
    (next: ConsequenceOfFailure) =>
      setFieldValues?.((prev) => ({
        ...prev,
        [ZONE_FIELD_IDS.COF]: wrapFieldValue(next),
      })),
    [setFieldValues]
  )

  const onAiFill = useCallback(
    (next: ConsequenceOfFailure) =>
      setFieldValues?.(
        (prev) => ({
          ...prev,
          [ZONE_FIELD_IDS.COF]: wrapFieldValue(next),
        }),
        { origin: { [ZONE_FIELD_IDS.COF]: 'llm' } }
      ),
    [setFieldValues]
  )

  return (
    <CommentIndicator anchor={{ type: 'cof', stepId }}>
      <ConsequenceOfFailureSection
        cof={cof}
        onChange={onChange}
        readonly={readonly}
        headerAction={
          config.agent && (
            <CofAiPrefillButton
              sectionId={config.id}
              permissions={
                (config.agentPermissions ?? []) as RolodexPermissionsValues[]
              }
              onApply={onAiFill}
              readonly={readonly}
            />
          )
        }
      />
    </CommentIndicator>
  )
}
